import { momentWithLocale as moment } from 'shared/locale/i18n.js';
import { formatClientDate, daysBetween } from 'shared/locale/datetime.js';

export function commonTrackingInfo(data) {
    let adobeEvents = `event82=${daysBetween(moment(), data.requestedDepartureDate)}`;
    if (data.requestedReturnDate && data.requestedReturnDate !== '') {
        adobeEvents += `,event83=${daysBetween(data.requestedDepartureDate, data.requestedReturnDate)}`;
    }

    return {
        fromdate: formatClientDate(data.requestedDepartureDate),
        todate: formatClientDate(data.requestedReturnDate),
        marketcustom2: 'fly',
        marketcustom6: data.requestedDestinationCountry,
        marketcustom8: data.requestedDestinationCity,
        marketcustom9: data.requestedDestination,
        marketcustom10: data.requestedOrigin,
        marketcustom11: data.requestedOriginCountry,
        marketcustom13: data.requestedOriginCity,
        adobeEvents,
    };
}
